export default "/public/dist/resources/Allegato1bisInformativa14febbraio2023.pdf";